import React from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Icon } from "@iconify/react";

const MainTab = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Define your tabs here. Adjust the paths to match your routing setup.
  const tabs = [
    { 
      name: "الرئيسية", 
      path: "", 
      icon: "solar:home-angle-bold-duotone" 
    },
    { 
      name: "لوحة التحكم", 
      path: "Dashboard", 
      icon: "solar:server-square-bold-duotone" 
    },
  ];
const isSelected = (route) => location.pathname === `/${route}`;
  return (
  <div  className=" w-full  bg-bg-primary  text-text-primary overflow-hidden transition-colors duration-300">
    <header 

      className="sticky top-0 z-10 w-full border-b border-border  transition-colors duration-300 "
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-4 md:px-8 py-3">
        
        {/* Navigation Tabs */}
        <nav className="flex items-center w-full justify-between gap-2 md:gap-4">
          {tabs.map((tab, idx) => {
            
            // Check if the current route matches the tab's path
            // (You can also use location.pathname.includes(tab.path) if you have nested routes)
           
            
            return (
              <button
                key={idx}
                onClick={() => navigate(tab.path)}
                className={`
                  flex items-center justify-center grow gap-2 px-4 py-2 md:px-6 md:py-2.5 rounded-full font-bold transition-all duration-300 text-sm md:text-base 
                  ${isSelected(tab.path) 
                    ? "bg-brand-light text-brand-primary " 
                    : "text-text-primary  hover:bg-bg-tertiary"
                  }
                `}
              >
                <Icon 
                  icon={tab.icon} 
                  className={`text-xl md:text-2xl transition-colors duration-300 ${
                    isSelected(tab.path) ? "text-brand-primary" : "text-text-primary"
                  }`}
                />
                <span>{tab.name}</span>
              </button>
            );
          })}
        </nav>

        {/*
        <div className="flex items-center gap-3">
          <button 
            className="flex items-center justify-center p-2.5 rounded-full bg-muted text-foreground border border-transparent hover:border-primary/50 hover:text-primary transition-all duration-300"
            aria-label="User Profile"
          >
            <Icon icon="solar:user-circle-bold-duotone" className="text-2xl" />
          </button>
        </div>
       */ }
      </div>
    </header>

   <Outlet />
  </div>
  );
};

export default MainTab;